import type { FunctionComponent, HTMLAttributes } from "react";

import PostiesEPaperDesktop from "./posties-e-paper-desktop.png";
import PostiesEPaperMobile from "./posties-e-paper-mobile.png";
import {
  Container,
  ContentAndButtonContainer,
  ContentContainer,
  Description,
  DescriptionContainer,
  Header,
  ImageContainer,
  StyledButton,
  StyledButtonContainer,
  StyledDesktopImage,
  StyledMobileImage,
  StyledStar,
  Wrapper,
} from "./styles";

export const EPaper: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ ...attributes }) => {
  const url =
    "https://assets.i-scmp.com/data/posties/Posties%202024-25%20Promotional%20Edition.pdf";

  return (
    <Container {...attributes}>
      <Wrapper>
        <ImageContainer>
          <StyledDesktopImage src={PostiesEPaperDesktop.src} />
          <StyledMobileImage src={PostiesEPaperMobile.src} />
          <StyledStar />
        </ImageContainer>
        <ContentAndButtonContainer>
          <ContentContainer>
            <Header>Posties ePaper</Header>
            <DescriptionContainer>
              <Description>
                Looking for another way to access the weekly edition? We’ve got you covered! This
                year, we are also offering an ePaper option for those who prefer to read the
                newspaper on their devices.
              </Description>
              <Description>
                You can also check out the section with past issues if you want to delve into
                previous editions.
              </Description>
            </DescriptionContainer>
          </ContentContainer>
          <StyledButtonContainer>
            <StyledButton pathname={url} target="_blank" variant="link">
              read sample
            </StyledButton>
          </StyledButtonContainer>
        </ContentAndButtonContainer>
      </Wrapper>
    </Container>
  );
};

EPaper.displayName = "EPaper";
